import type { LineItem } from "@/apis/gql/types";

export enum OperationType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

export type OperationActionUpdate = {
  type: OperationType.UPDATE;
  lineItemId: string;
  changes: Partial<LineItem>;
  timestamp: Date;
  synced?: boolean;
};

export type OperationActionCreate = {
  type: OperationType.CREATE;
  lineItemId: string;
  lineItem: LineItem;
  timestamp: Date;
  synced?: boolean;
};

export type OperationActionDelete = {
  type: OperationType.DELETE;
  lineItemId: string;
  timestamp: Date;
  synced?: boolean;
};

export type OperationAction =
  | OperationActionUpdate
  | OperationActionCreate
  | OperationActionDelete;
